export const products = [
  {
    id: 1,
    name: "Laptop",
    price: 1500,
    description: "A high-performance laptop for all your needs.",
    image:
      "https://i.pinimg.com/736x/cb/87/93/cb8793c35f41fb44c342cfe840080c19.jpg",
  },
  {
    id: 2,
    name: "Smartphone",
    price: 700,
    description: "A modern smartphone with an excellent camera.",
    image:
      "https://i.pinimg.com/736x/af/97/f4/af97f4d7474ec38ec07a0bccec057cf1.jpg",
  },
  {
    id: 3,
    name: "Headphones",
    price: 200,
    description: "Noise-cancelling headphones for better focus.",
    image:
      "https://i.pinimg.com/736x/13/fa/01/13fa01d2ad8c5ee07d4af17f41e90541.jpg",
  },
];
